/* components/UsersTable.js */
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import { ROLES } from "constants/Constants";

const UsersTable = ({
    columns,
    data,
    setData,
    fetchUsers,
    userForEdit,
    setUserForEdit,
    openEditUserModal,
    setOpenEditUserModal,
    organizationDetails,
    allDepartments,
    cookies,
}) => {
    // Enhanced columns with actions
    const enhancedColumns = columns.map(column => {
        if (column.accessorKey === "status") {
            return {
                ...column,
                cell: ({ row }) => {
                    const isActive = !row.original.deleted;
                    return (
                        <span
                            className={`badge rounded-pill px-3 py-2 ${isActive ? "bg-success" : "bg-danger"
                                }`}
                            style={{
                                fontSize: "0.8rem",
                                fontWeight: "600",
                                color: "white",
                            }}
                        >
                            {isActive ? "ACTIVE" : "INACTIVE"}
                        </span>
                    );
                },
            };
        }

        if (column.accessorKey === "actions") {
            return {
                ...column,
                cell: ({ row }) => {
                    return (
                        <div>
                            {row.original.roleId === ROLES.ORGANIZATION_COORDINATOR ? null : (
                                <Tooltip title="Update">
                                    <IconButton
                                        onClick={() => {
                                            setOpenEditUserModal(true);
                                            setUserForEdit(row.original);
                                        }}
                                        size="small"
                                        sx={{
                                            color: "#224D99",
                                            "&:hover": {
                                                backgroundColor: "rgba(34, 75, 153, 0.1)",
                                            },
                                        }}
                                    >
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </div>
                    );
                },
            };
        }

        return column;
    });

    return (
        <div style={{ width: "100%" }}>
            <TanstackTable
                columns={enhancedColumns}
                data={data}
                pagination={true}
            />
        </div>
    );
};

export default UsersTable;